import React from "react";
import PropTypes from "prop-types";

import { Overlay, Tooltip } from "react-bootstrap";
import TypesUtils from "../../inumet_js_lib/utils/typesUtils";

class ErrorOverlay extends React.Component {
  render() {
    let placement = this.props.placement ? this.props.placement : "top";
    return (
      <Overlay
        target={this.props.componentRef}
        show={TypesUtils.notUndefOrNull(this.props.errorText)}
        placement={placement}
      >
        {(props) => (
          <Tooltip id="overlay-example" {...props}>
            {this.props.errorText}
          </Tooltip>
        )}
      </Overlay>
    );
  }
}

ErrorOverlay.propTypes = {
  errorText: PropTypes.string,
  componentRef: PropTypes.object,
  placement: PropTypes.string,
};

export { ErrorOverlay as default };
